import React from 'react';
import comma from 'comma-number';
import density from 'graphology-metrics/density';
import inferType from 'graphology-utils/infer-type';
import Hint from '../misc/Hint';
import './GraphInformation.scss';
function UnderlyingInformation(_a) {
    var hint = _a.hint, children = _a.children, _b = _a.raw, raw = _b === void 0 ? false : _b;
    return (React.createElement(Hint, { hint: hint, size: "large", style: !raw
            ? { textDecoration: 'underline dotted', cursor: 'pointer' }
            : { cursor: 'pointer' } }, children));
}
export default function GraphInformation(_a) {
    var graph = _a.graph, weighted = _a.weighted;
    var order = comma(graph.order);
    var size = comma(graph.size);
    var type = inferType(graph);
    var attr = graph.getAttributes();
    var infos = {
        multi: { label: '', hint: '' },
        type: { hint: '' }
    };
    var d = density(graph);
    if (type === 'directed') {
        infos.type.hint = 'Your graph only contains directed edges.';
    }
    else if (type === 'undirected') {
        infos.type.hint = 'Your graph only contains undirected edges.';
    }
    else {
        infos.type.hint = 'Your graph contains both directed and undirected edges.';
    }
    if (graph.multi) {
        infos.multi.label = 'Multi';
        infos.multi.hint =
            'Your graph may contains more than a single edge connecting one node to another.';
    }
    else {
        infos.multi.label = 'Simple';
        infos.multi.hint =
            'Your graph only accepts a single edge connecting one node to another.';
    }
    return (React.createElement("div", { id: "GraphInformation" },
        React.createElement("h5", { className: "title is-6" }, "Graph information"),
        React.createElement("p", null,
            React.createElement(UnderlyingInformation, { hint: infos.multi.hint }, infos.multi.label),
            ', ',
            weighted && (React.createElement(React.Fragment, null,
                React.createElement(UnderlyingInformation, { hint: "Your graph's edges may have different weights." }, "weighted"),
                ', ')),
            React.createElement(UnderlyingInformation, { hint: infos.type.hint }, type),
            ' ',
            "graph"),
        React.createElement("p", null,
            React.createElement("strong", null, order),
            " nodes and ",
            React.createElement("strong", null, size),
            " edges"),
        React.createElement("p", null,
            React.createElement(UnderlyingInformation, { hint: "Proportion of possible edges actually existing in your graph." }, "Density"),
            ": ~",
            React.createElement("strong", null, d.toFixed(4)))));
}
